module.exports = __webpack_public_path__ + "img/belun.f3aa31e8.png";